// src/routes/domains/newzealand/index.ts
import { nzRoutes } from './nz.routes';
import type { AppRoute } from '../../core/types';

/**
 * Lazy export wrapper for New Zealand routes.
 * Enables code splitting: the NZ routes chunk will only load when needed.
 */
export const loadNzRoutes = (): Promise<AppRoute[]> => {
  return Promise.resolve(nzRoutes);
};